export const GlobalStyles = {
  // Layout
  pageContainer: `min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-950 transition-all duration-300`,
  contentContainer: `w-full max-w-full p-4 md:p-5 lg:p-6`,

  // Cards
  card: `bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl border border-gray-200/50 dark:border-gray-700/50 shadow-md p-5 transition-all duration-300`,
  cardHover: `bg-white/80 dark:bg-gray-800/80 backdrop-blur-sm rounded-xl border border-gray-200/50 dark:border-gray-700/50 shadow-md p-5 transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5 hover:border-primary/20`,

  // Buttons
  button: `flex items-center justify-center font-medium rounded-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary/30 active:scale-[0.98]`,

  buttonPrimary: `bg-gradient-to-r from-primary to-primary/90 text-white shadow-sm hover:shadow-md hover:from-primary/90 hover:to-primary/80`,
  buttonOutline: `border border-primary text-primary bg-white/10 dark:bg-transparent hover:bg-primary/5 dark:hover:bg-primary/10`,
  buttonGhost: `text-gray-700 dark:text-gray-300 hover:bg-gray-100/80 dark:hover:bg-gray-700/80 hover:text-gray-900 dark:hover:text-white`,
  buttonDanger: `bg-gradient-to-r from-red-500 to-red-600 text-white shadow-sm hover:shadow-md hover:from-red-600 hover:to-red-500`,
  buttonSuccess: `bg-gradient-to-r from-green-500 to-green-600 text-white shadow-sm hover:shadow-md hover:from-green-600 hover:to-green-500`,
  buttonError: `bg-gradient-to-r from-red-500 to-red-600 text-white shadow-sm hover:shadow-md hover:from-red-600 hover:to-red-500`,

  buttonSmall: "px-3 py-1.5 text-sm",
  buttonMedium: "px-4 py-2.5 text-base",
  buttonLarge: "px-5 py-3 text-lg",

  // Inputs
  input: `w-full bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm border border-gray-200 dark:border-gray-700 rounded-lg px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all duration-300 text-gray-900 dark:text-white placeholder:text-gray-500/80 dark:placeholder:text-gray-400/80 text-sm`,
  inputError: "border-red-500 focus:ring-red-500/20 focus:border-red-500",
  inputLabel: `font-medium text-sm mb-1.5 text-gray-700 dark:text-gray-300`,

  // Text
  heading1: "text-3xl font-bold text-gray-900 dark:text-white",
  heading2: "text-2xl font-bold text-gray-900 dark:text-white",
  heading3: "text-lg font-semibold text-gray-900 dark:text-white",
  bodyText: "text-gray-600 dark:text-gray-400 text-sm leading-relaxed",
  smallText: "text-xs text-gray-500 dark:text-gray-400",

  // Badges
  badge: `rounded-full inline-flex items-center justify-center px-2.5 py-0.5 text-xs font-medium backdrop-blur-sm`,
  badgeSuccess:
    "bg-green-500/10 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-800/50",
  badgeWarning:
    "bg-yellow-500/10 text-yellow-700 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-800/50",
  badgeError:
    "bg-red-500/10 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800/50",
  badgeInfo:
    "bg-blue-500/10 text-blue-700 dark:text-blue-300 border border-blue-200 dark:border-blue-800/50",
  badgePrimary:
    "bg-primary/10 text-primary dark:text-primary/80 border border-primary/20 dark:border-primary/30",

  // Tables
  table: `w-full border-collapse rounded-lg overflow-hidden text-sm`,
  tableHeader: `bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-800/50 dark:to-gray-900/50 font-semibold text-gray-700 dark:text-gray-300 backdrop-blur-sm`,
  tableRow:
    "border-b border-gray-100 dark:border-gray-700/50 hover:bg-gray-50/50 dark:hover:bg-gray-800/30 transition-all duration-200",
  tableCell: "px-4 py-3",

  // Alerts
  alert: `rounded-lg p-3.5 flex items-start gap-3 backdrop-blur-sm border`,
  alertInfo:
    "bg-blue-500/5 text-blue-700 dark:text-blue-300 border-blue-200 dark:border-blue-800/50",
  alertSuccess:
    "bg-green-500/5 text-green-700 dark:text-green-300 border-green-200 dark:border-green-800/50",
  alertWarning:
    "bg-yellow-500/5 text-yellow-700 dark:text-yellow-300 border-yellow-200 dark:border-yellow-800/50",
  alertError:
    "bg-red-500/5 text-red-700 dark:text-red-300 border-red-200 dark:border-red-800/50",

  // Loaders
  spinner:
    "animate-spin rounded-full border-t-2 border-1 border-dashed border-t-transparent border-primary",

  // Grid
  gridCols1: "grid grid-cols-1",
  gridCols2: "grid grid-cols-1 md:grid-cols-2",
  gridCols3: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
  gridCols4: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4",

  // Spacing
  sectionSpacing: "mb-6",
  cardSpacing: "space-y-4",

  // Misc
  iconButton:
    "p-2 rounded-lg hover:bg-gray-100/80 dark:hover:bg-gray-700/80 transition-all duration-200 active:scale-95",

  // Chat specific styles
  chatMessageOwn:
    "bg-gradient-to-r from-primary to-primary/90 text-white rounded-2xl rounded-br-sm shadow-sm",
  chatMessageOther:
    "bg-gray-100 dark:bg-gray-800/80 text-gray-900 dark:text-white rounded-2xl rounded-bl-sm shadow-sm",
  chatBubble: "px-4 py-2.5 max-w-[85%] text-sm",
  chatTime: "text-xs opacity-70 mt-1.5",
  chatAttachment:
    "mt-2 rounded-lg overflow-hidden border border-gray-200 dark:border-gray-700/50 shadow-sm",

  // Modal styles
  modalBackdrop:
    "fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-all duration-300",
  modalContainer:
    "fixed z-50 bg-white dark:bg-gray-900 shadow-xl rounded-xl border border-gray-200/50 dark:border-gray-700/50",

  // Input styles for chat
  chatInput:
    "min-h-[42px] max-h-[120px] resize-none pr-12 border border-gray-200 dark:border-gray-700 focus:border-primary transition-all duration-300 rounded-xl bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm text-sm",

  // Button styles for chat
  chatButton:
    "p-2 rounded-lg hover:bg-gray-100/80 dark:hover:bg-gray-800/80 transition-all duration-200 active:scale-95",
  chatSendButton:
    "p-2.5 rounded-full bg-gradient-to-r from-primary to-primary/90 hover:from-primary/90 hover:to-primary/80 text-white shadow-sm hover:shadow-md transition-all duration-300",

  // Badge styles
  badgeNotification:
    "absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full h-4 w-4 flex items-center justify-center shadow border border-white dark:border-gray-900",
};
